<script lang="ts">
 
  export let isPaused = false;
  export let rootElement;
   
</script>

<style lang="scss">
  * {
    svg {
    overflow:visible;
  }
    

  .shapes > * {
    opacity: 0;
    animation-duration: 0.75s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  .shapes {
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
    animation-name: roll;
    animation-direction: alternate;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
  }

  .paused .shapes {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
  }



  @keyframes roll {
    0%,
    12.5% {
      transform: translateX(0) translateY(0);
    }
    12.5%,
    25% {
      transform: translateX(30%) translateY(-8%);
    }
    25%,
    37.5% {
      transform: translateX(60%) translateY(-16%);
    }
    37.5%,
    50% {
      transform: translateX(30%) translateY(-24%);
    }
    50%,
    62.5% {
      transform: translateX(0) translateY(-32%);
    }
    62.5%,
    75% {
      transform: translateX(-30%) translateY(-24%);
    }
    75%,
    87.5% {
      transform: translateX(-60%) translateY(-8%);
    }
    87.5%,
    100% {
      transform: translateX(0) translateY(0);
    }
  }
  @keyframes agility-circle-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #agility-circle-1 {
    animation-name: agility-circle-1;
  }
  @keyframes agility-circle-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #agility-circle-2 {
    animation-name: agility-circle-2;
  }
  }
</style>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201.8 545.1" height="100%" width="100%">
  <g class:paused={isPaused}>
    <g id="book">
      <path
        fill="var(--shirt)"
        d="M124 427H70c-1 0-3 0-3-2-1-5 1-10 3-16l4-1h43c4 0 5 2 5 5l2 8 1 4-1 2Z"
      />
      <path
        fill="var(--book)"
        d="M70 427h54c0 10 0 10-10 10H74c-2 0-5 1-6-2a6 6 0 0 1 2-6v-2ZM125 425l-1-4 1 4ZM124 427l1-2c1 1 1 2-1 2Z"
      />
    </g>
    <g class="shapes" bind:this={rootElement}>
      <g id="agility-circle-2">
        <path
          fill="var(--hair)"
          d="M91 0c3 2 6 3 8 6 12 10 14 23 12 37-3 1-2 5-3 7l-3-16c-1-3-2-4-5-2-11 8-24 8-37 6-1 0-4-1-3 1 1 6-3 10-3 15l-2 1a1 1 0 0 1 0-1l-1-2-1-1a76 76 0 0 1-2-35c1-6 4-9 10-11 5-1 10-2 14-5Z"
        />
        <path
          fill="var(--flesh)"
          d="M179 216c-5 9-14 12-22 16-3 2-7 3-9 8-5 2-11 4-13 9l-11 23a3 3 0 0 0-3 3c-4 3-9 3-14-1v-4l5-5c3 0 4-2 5-4a2 2 0 0 0-1-2c-3-1-4 2-6 3v1l-5 1c-2 2-3 2-4 0s-1-4 2-5 5-3 7-5c1 0 3 0 4-2l-1-2c-2-1-5-1-5 2a24 24 0 0 1-4 0l-3-1a3 3 0 0 1 0-4l4-4c3-1 2-3 0-5l-7-7c-3-2-3-5-1-7s5-2 7 1c1 3 4 3 6 3 3 0 5-1 7 2s5 2 7 0c4-2 8-2 10-7 4-2 7-6 10-10 3-2 7-3 5-8-4-10-5-21-5-32 9 0 16-4 22-10 2-1 3-4 6-4l4 27 3 11"
        />
        <path
          fill="var(--flesh)"
          d="M5 162c9-1 15 5 22 8 3 1 7 2 7 7l-7 21c-2 5-1 12-1 18-2 14-6 27-6 41a100 100 0 0 0 2 23 42 42 0 0 1 0 16c0 5-1 10 1 14a6 6 0 0 1-2 9c-3 1-5 1-8-2-7-6-8-14-12-22a6 6 0 0 1 0-5c6-12 3-24 3-36-1-16-5-32-4-48 1-7 2-14 5-21 2-7 1-14 2-21l-2-2Z"
        />
        <path
          fill="var(--flesh)"
          d="M87 369h3c-2 11 0 23-6 33v7a88 88 0 0 1-3 40c-4 12-3 24-1 36-1 4-4 3-7 3-4-1-7-1-7 5-4-4-2-8-4-11 1-6-2-12-3-17l-7-37a36 36 0 0 1 2-20c3-9 3-19 1-29-1-3-3-7-2-10l17 4c6 1 12 0 17-4ZM111 362l5 3c11 10 22 10 34 5l1 22v6c-4 8-3 17-3 26 0 10-4 18-10 26-4 5-9 10-7 18-4 0-9-3-12 2-1 1-2 2-4 1-2 0-2-2-1-4 0-3 2-7-1-10 1-9 2-18 0-28a22 22 0 0 1 1-16c7-13 5-26 0-38-2-4-2-9-3-13Z"
        />
        <path
          fill="var(--hair)"
          d="M113 457c3 3 1 7 1 10-1 2-1 4 1 4 2 1 3 0 4-1 3-5 8-2 12-2 3 15 3 32 8 47 1 5 1 9-4 12a14 14 0 0 1-15 0c-6-3-10-9-10-15a76 76 0 0 0-5-29c-4-11 3-18 8-26ZM62 482c2 3 0 7 4 11 0-6 3-6 7-5 3 0 6 1 7-3 2 1 4 3 3 6-1 11 1 21 4 31a36 36 0 0 1 2 6c1 13-6 19-19 15-12-5-18-17-14-30l4-25 2-6Z"
        />
        <path
          fill="var(--pants)"
          d="M147 273c-6-1-11 4-17 5a9 9 0 0 1-6 2c-8 4-17 7-26 8-16 1-31 1-44-9-5-4-10-8-16-10l-1 12 7 76c1 5 4 8 8 10l1 2 17 4c6 1 12 0 17-4h3c2-1 4-3 4-6l2-18c-1-5 0-9 1-14 2 4 0 9 1 14-2 9 2 14 11 16l2 1c2 0 4 2 5 3 11 10 22 10 34 5 2-2 2-4 3-7 2-30 1-60-6-90Z"
        />
        <path
          fill="var(--flesh)"
          d="M60 70c-3 0-3-4-5-5a1 1 0 0 0 0-1l-5-12 3-1 1 1 1 2a1 1 0 0 0 0 1 14 14 0 0 0 3 9l2 6Z"
        />
        <path
          fill="var(--flesh)"
          d="m60 70-2-6a23 23 0 0 0-1-9c0-6 4-10 3-16-1-2 2-1 3-1 13 2 26 2 37-6 3-2 4-1 5 2l3 16c1-2 0-6 3-7 3-2 5-2 5 2 0 8 0 15-5 22-4 4-3 12 1 15 6 2 7 9 3 14-2 2-3 3-3 6-10 10-23 13-35 7a22 22 0 0 1-12-19l-1-6-4-14Z"
        />
        <path
          fill="var(--shirt)"
          d="M112 102c0-3 1-4 3-6 4-5 3-12-3-14 3-1 7-3 10 1-3 2-3 5-3 7 1 6-2 10-7 12Z"
        />
        <path
          fill="var(--pants)"
          d="M57 55a23 23 0 0 1 1 9 14 14 0 0 1-3-9ZM55 54Z"
        />
        <path
          fill="var(--shirt)"
          d="m175 147-12-31c-2-7-6-13-13-16l-28-17c-3 2-3 5-3 7 1 6-2 10-7 12-10 10-23 13-35 7a22 22 0 0 1-12-19l-1-6c-3-1-5 2-8 2a19 19 0 0 1-4 4c-7 4-13 7-19 12-17 16-24 37-28 60 9-1 15 5 22 8 3 1 7 2 7 7 5 1 4 5 4 8a423 423 0 0 1-4 74c0 5 0 8 4 11 6 1 11 5 16 9 13 11 28 10 44 9 9-1 18-4 26-8v-5c2 0 4 0 6 3 6-1 11-5 17-5 2-2 4-2 4-5-1-9 0-19-3-28-5 2-11 4-13 9l-11 24v2h-3c-4 3-9 3-13-1-2-2-2-3-1-4l5-5-2-2-5 1c-2 2-3 3-4 0-1-2-1-4 2-5s5-3 7-5a2 2 0 0 0-2-2 24 24 0 0 1-4 0l-3-1a3 3 0 0 1 0-4l4-4c3-1 2-3 0-5l-7-7c-3-2-3-5-1-7s5-1 7 1c1 3 4 3 6 3 3 0 5-1 7 2s5 2 7 0c4-2 8-2 10-7a17 17 0 0 0-2 0 17 17 0 0 1 2 0c5-2 7-6 10-10 1-11-1-21-1-32 0-2-3-6 1-8 9 0 16-4 22-9 2-2 3-4 6-5 5-3 5-7 3-12Z"
        />
        <path
          fill="var(--shirt)"
          d="M110 263v-1c2-1 3-4 6-3a2 2 0 0 1 1 2c-1 2-2 4-5 4l-2-2ZM108 252c0-3 3-3 5-2l1 2c-1 2-2 2-4 2a2 2 0 0 0-2-2ZM124 275c2 0 4 0 6 3a9 9 0 0 1-6 2ZM124 272v3h-3a3 3 0 0 1 3-3Z"
        />
      </g>
      <g id="agility-circle-1">
        <path
          d="M58 272c17 1 34 7 50 12 14 5 28 4 42-2a8 8 0 0 1 2-1c-4 25-13 49-16 73-1 4-4 5-5 7-10 5-20 6-30 3-2-2-3-1-4 0-1 3-1 6-4 7-11 1-22 2-33-3l-4-7c-7-27-6-54-2-81v-3c2-1 4-3 4-5Z"
          fill="var(--pants)"
        />
        <path
          fill="var(--flesh)"
          d="M101 364c10 3 20 2 30-3 1 8-2 15-4 22s-3 13-1 19c3 15 0 30-5 44-4 14-9 28-10 43-1 3-1 3-2 2-5-2-10-2-15 2-1-1 0-3-2-4 4-4 5-8 5-13l-2-39a40 40 0 0 1 3-18c2-7 2-14 0-21-2-11 1-23 3-34Z"
        />
        <path
          fill="var(--flesh)"
          d="M58 272c0 2-2 4-4 5a23 23 0 0 1-3-2c-4-2-5 0-5 4l1 14a29 29 0 0 1 0 13c-2 3-3-1-4-1-1-1-1-4-3-4 0-2 0-3-2-3-4-10-7-20-6-32 1-13-6-25-10-37-3-11-8-22-7-34a48 48 0 0 1 5-22l2-5c9 3 13 11 20 16 0 2 0 4 2 5-5 3-7 7-4 13s2 11 2 17v20c0 6 2 11 5 15s3 1 4-1c1 3 0 7 4 8 2 0 1 3 1 5 1 2 0 4 2 6Z"
        />
        <path
          fill="var(--hair)"
          d="m99 61-1-25c-1-14 7-23 21-24 12-1 23 3 33 9 5 3 6 9 6 15a70 70 0 0 1-1 25c-2 2-5 3-5-2v-3c0-3-1-4-5-2a44 44 0 0 1-19 3c-7 0-14 1-20-3l1 7c1 4-6 6-5 10v3a3 3 0 0 1-2-3c0-4-1-7-3-10Z"
        />
        <path
          fill="var(--flesh)"
          d="M60 368c11 5 22 4 33 3 0 10 1 19-4 28-1 2 0 5 1 7 2 9 0 17-4 25-6 11-10 22-7 34-1 2-1 5-5 2a9 9 0 0 0-10 0c-2 3-2-1-3-1 5-8 2-17 0-26-4-15-5-30 0-46 2-6 0-13 0-20a33 33 0 0 1-1-6Z"
        />
        <path
          fill="var(--flesh)"
          d="M167 182a74 74 0 0 0 24-5h8a15 15 0 0 0-1 9c2 9 1 18 2 27 1 10-6 17-12 24a46 46 0 0 0-13 24 11 11 0 0 1-1 3c-2 4-4 4-7 0l-8-14c0-5-4-8-5-12 0-8-4-17-3-25h5c2 3-2 7 4 9 3 7 7 8 10 2 3-5 5-11 2-18a47 47 0 0 1-5-24Z"
        />
        <path
          fill="var(--hair)"
          d="m92 489 3 4c4-4 9-4 14-2 1 1 1 1 2-2 2 13 11 24 11 38a19 19 0 0 1-16 18c-5 1-11-1-12-7-6-15-5-30-4-46a4 4 0 0 1 2-3ZM61 466c1 0 1 4 4 1a9 9 0 0 1 9 0c4 3 4 0 5-2 3 1 3 4 3 6 1 13 1 27-1 40-2 6-4 10-11 11-5 1-13-3-15-9-3-5-4-10-3-16 4-10 7-20 9-31Z"
        />
        <path fill="var(--shirt)" d="M149 108z" />
        <path
          fill="var(--flesh)"
          d="M104 74a3 3 0 0 1-2-3c0-4-1-7-3-10-4-1-5 1-4 5 1 7 3 14 9 20 1 4-2 4-5 5v6c-2 16 12 29 26 28 9-1 17-6 23-13l1-4c5-2 1-7 2-10-2-1-2-2-2-4l7-20c1-4 3-9 1-13-2 2-5 3-5-2v-3c0-3-1-4-5-2a44 44 0 0 1-19 3c-7 0-14 1-20-3l1 8-5 3v9-3M40 301c2 0 2 3 3 4 1 0 2 4 4 1v4c-1 1-3 0-4-1a11 11 0 0 1-3-8ZM38 298c1 0 2 1 2 3-2-1-2-2-2-3Z"
        />
        <path
          fill="var(--shirt)"
          d="m201 168-9-28c-4-13-9-24-23-29-7-3-10-10-18-13-1 3 3 8-2 10l-1 4c-6 7-14 12-23 13-14 1-28-12-26-28v-6c-16 4-31 11-46 21-6 4-11 9-13 17-2 6-5 11-9 16a51 51 0 0 0-9 23c9 3 13 11 20 16l5 1c2 3 4 1 6 0l5-8c-1 26-4 51-7 76 1 3 0 7 4 8 2 0 1 3 1 5 1 2 0 4 2 6 17 1 34 7 50 12 14 5 28 4 42-2a8 8 0 0 1 2-1 5 5 0 0 1 3-2c4 0 3-4 4-6v-23c0-5-4-9-4-12-1-8-5-17-3-25h4a2 2 0 0 0 2-1 3 3 0 0 0 1-1 3 3 0 0 1-1 1 2 2 0 0 1-2 1c2 3-2 7 4 9 2-5 0-10 1-15l3-21c0-2 0-4 3-4a74 74 0 0 0 24-5h8c2-2 4-5 2-9Z"
        />
        <path
          fill="var(--flesh)"
          d="M53 185c-2 5-7 1-9 4-2-1-2-3-2-5l4 1c3 3 5 1 7 0Z"
        />
      </g>
    </g>
  </g>
{#if isPaused}
<svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
{/if}
</svg>
